import { arraysAreEqual } from "./arraysAreEqual.js";
export const headsAreSame = (a, b) => {
    return arraysAreEqual(a, b);
};
